export var Env;
(function (Env) {
    Env["dummy"] = "dummy";
    Env["local"] = "local";
    Env["local-epaper"] = "local-epaper";
    Env["dev"] = "dev";
    Env["dev-epaper"] = "dev-epaper";
    Env["qa-us"] = "qa-us";
    Env["qa-apac"] = "qa-apac";
    Env["qa-eu"] = "qa-eu";
    Env["qa-epaper"] = "qa-epaper";
    Env["staging-epaper"] = "staging-epaper";
    Env["uat-epaper"] = "uat-epaper";
    Env["prod-us"] = "prod-us";
    Env["prod-apac"] = "prod-apac";
    Env["prod-eu"] = "prod-eu";
    Env["prod-epaper"] = "prod-epaper";
})(Env || (Env = {}));
//has an analogous 'TokenizationPaymentMethod' in the api code
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["notPresent"] = "notPresent";
    PaymentMethod["creditCard"] = "CC";
    PaymentMethod["ACH"] = "ACH";
    PaymentMethod["eCheck"] = "ECHECK";
    PaymentMethod["ePaperToken"] = "ePaperToken";
    PaymentMethod["webDropInCreditCard"] = "webDropInCreditCard";
    PaymentMethod["webDropInPaypal"] = "webDropInPaypal";
    PaymentMethod["webDropInGooglePay"] = "webDropInGooglePay";
    PaymentMethod["webComponentPaypal"] = "webComponentPaypal";
    PaymentMethod["webComponentCreditCard"] = "webComponentCreditCard";
    PaymentMethod["webComponentVirtualAccount"] = "webComponentVirtualAccount";
    PaymentMethod["webComponentBoleto"] = "webComponentBoleto";
    PaymentMethod["webComponentBankTransfer"] = "webComponentBankTransfer";
    PaymentMethod["webComponentCash"] = "webComponentCash";
    PaymentMethod["agentAssisted"] = "AGENT_ASSISTED";
})(PaymentMethod || (PaymentMethod = {}));
//only used in tests
export var SessionPaymentType;
(function (SessionPaymentType) {
    SessionPaymentType["FORM_ENCRYPTION"] = "FORM_ENCRYPTION";
    SessionPaymentType["PAYMENT_LINK"] = "PAYMENT_LINK";
    SessionPaymentType["AGENT_ASSISTED"] = "AGENT_ASSISTED";
})(SessionPaymentType || (SessionPaymentType = {}));
